import React from 'react'
import DetailCard from '../Main/DetailCard'

const value = {
  id: 1,
  heading: "Hand Pallet Truck",
  intro : [
    "The Reel/Paper Roll Pallet Truck lifts cylindrical loads like the rolls of paper, fabric, carpet, steel, etc. directly from the floor and then transports them conveniently.",
  ],
  features: [
    "Tandem load roller sgive easy running over uneven floors",
    "Most compact and popular design of pump unit",
    "Long operating life and low maintence."
  ],
  imageUrl: "/images/Hydraulic-Hand-Pallet.jpg"
}
const HandPalletTruck = () => {
  return (
  <>
  <DetailCard lists={value}/>
  </>
  )
}

export default HandPalletTruck